module.exports = __webpack_public_path__ + "static/media/1-d.0d35faf0.png";